import React, { useEffect } from "react";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Carousel from "../../Carousel";
import RecoverySection from "../../Recovery";
import Portfolio from "../../Portfolio";
import { counters } from "../../Constants/Counters";

const ZeroWastageFood = () => {
  useEffect(() => {
    // Initialize Bootstrap carousel
    const carouselElement = document.getElementById("hero-carousel");
    if (carouselElement) {
      new window.bootstrap.Carousel(carouselElement);
    }
  }, []);

  const bannersItems = [
    {
      img: "/assets/img/m-zwf/S-1.jpg",
    },

    // {
    //   img: "assets/img/mCarousel/mcr4.jpg",
    //   title: "Title 4",
    //   description: "Description for image 4.",
    // },
    // {
    //   img: "assets/img/mCarousel/mcr5.jpg",
    //   title: "Title 5",
    //   description: "Description for image 5.",
    // },
    // {
    //   img: "assets/img/mCarousel/mcr6.jpg",
    //   title: "Title 6",
    //   description: "Description for image 6.",
    // },
    // {
    //   img: "assets/img/mCarousel/mcr7.jpg",
    //   title: "Title 7",
    //   description: "Description for image 7.",
    // },
    // {
    //   img: "assets/img/mCarousel/mcr8.jpg",
    //   title: "Title 8",
    //   description: "Description for image 8.",
    // },
  ];

  const portfolioImage = [
    {
      img: "/assets/img/m-zwf/G-1.jpg",
      title: "Harvesting Hope: Volunteers in Action",
      description:
      "A warm meal, a kind gesture. Volunteers bend low not just to serve food, but to lift spirits.",
    },
    {
      img: "/assets/img/m-zwf/G-2.jpg",
      title: "A Meal for Every Heart",
      description:
        "Hands full of compassion stir pots of generosity. In the middle of humble surroundings, these women serve not just meals — but dignity and belonging. Every ladle carries a message: “You are not forgotten.”",
    },
    {
      img: "/assets/img/m-zwf/G-3.jpg",
      title: "Bridging the Gap: Food for All",
      description:
        "An aged hand reaches out, and youth responds with care. Generations connect over a shared meal, proving that kindness needs no age. Her bowed head blesses the silent warriors who feed her without asking anything in return.",
    },
    {
      img: "/assets/img/m-zwf/G-4.jpg",
      title: "Turning Leftovers into Lifelines",
      description:
        "Amidst fields and dust, joy brews in giant vessels. Children run in excitement while volunteers tirelessly feed every soul. Nature watches as humanity comes alive, turning a barren patch into a place of celebration.",
    },
    {
      img: "/assets/img/m-zwf/G-5.jpg",
      title: "Feeding the Future: A Community Effort",
      description:
        "Tiny feet, big hopes. With plates clutched tight, these children wait patiently, knowing someone cares. Their innocence deserves love, and Mallabhum Prayas ensures they are seen, heard, and never left hungry again..",
    },
    {
      img: "/assets/img/m-zwf/G-6.jpg",
      title: "Sustaining Lives: The Power of Community",
      description:
        "Behind every plate served is a team that believes in compassion. These everyday heroes prepare meals with heart and purpose, standing proud beside the food that will soon bring relief to many empty stomachs",
    },
    {
      img: "/assets/img/m-zwf/G-7.jpg",
      title: "From Celebration to Compassion",
      description:
        "In the dusty corners of forgotten streets, love finds its way through ladles and laughter. Volunteers kneel not just to serve—but to connect, reminding every child and family that kindness still walks among them, plate by plate.",
    },
    {
      img: "/assets/img/m-zwf/G-8.jpg",
      title: "Gathering Generosity: Volunteers Collecting Food",
      description:
        "With the van packed and hearts full, our volunteers stand ready to deliver not just food, but comfort. These meals are messengers—traveling across villages to reach the unreached, feeding lives and restoring faith in humanity.",
    },
  ];
  return (
    <main className="main">
      <Carousel bannersItems={bannersItems} />
      <RecoverySection
        counters={[counters[0]]}
        title="THOSE WHO STILL CAN'T DREAM"
      />
      <Portfolio
        portfolioHeader="Zero Wastage Food: SHARING EXTRA, SERVING HOPE"
        description="Every plate saved is a story of dignity restored. Through the Zero Wastage Food initiative by Mallabhum Prayas, we collect surplus food from events and serve it to those who go hungry and unheard. It’s not just about food—it’s about respect, care, and second chances."
        portfolioImage={portfolioImage}
      />
    </main>
  );
};

export default ZeroWastageFood;
